module.exports = __webpack_public_path__ + "static/media/cross-white.b195082a.svg";